require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kalkulator-wynagrodzen.json") })
        }
      }, "path---kalkulator-wynagrodzen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kalkulator-wynagrodzen!./.cache/json/kalkulator-wynagrodzen.json
// module id = 518
// module chunks = 231608221292675